module.exports = __webpack_public_path__ + "media/images/shapes/curves/curve-4-df597ba3e56ca143750f0233e36a3427e9d46ac18a12d5c00b39d4d70ca86f32.svg";